import { render, staticRenderFns } from "./WallpaperEditor.vue?vue&type=template&id=68fc415f&scoped=true&"
import script from "./WallpaperEditor.vue?vue&type=script&lang=js&"
export * from "./WallpaperEditor.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperEditor.vue?vue&type=style&index=0&id=68fc415f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc415f",
  null
  
)

export default component.exports